<app-nav></app-nav>
<!-- <div *ngIf="message;">
	<h1>{{ message.data }}</h1>
	<h2>{{ message.data }}</h2>
  </div>
  <div *ngIf="!message;">
	No Message Arrived
  </div> -->